export const getNodeEnv = () => {
  const env =
    (process.env.REACT_APP_ENCHARGE_NODE_ENV as undefined | "staging") ||
    process.env.NODE_ENV ||
    "production";
  return env;
};
